import React from 'react';
import { useCollection } from '../data/firestore';
import { useAuth, signOut } from '../AuthContext';
import { MarkdownLite } from './Plan';

// IDP enterprise rate card (/idp-pricing) — PRIVATE. Content lives in the
// Firestore `idpSections` collection (allowlist-gated in the rules, same
// pattern as /plan and /docs); this page is just the viewer. Nothing
// confidential ships in the JS bundle. Content is written via admin tooling.
export default function IDPPricing() {
  const { user } = useAuth();
  const { docs: sections, error } = useCollection('idpSections', {
    orderBy: 'order',
    dir: 'asc',
  });

  if (error) {
    const denied = /permission/i.test(error);
    return (
      <div className="cs-page">
        <div className="cs-empty" style={{ maxWidth: 520 }}>
          {denied ? (
            <>
              <p style={{ marginTop: 0 }}>
                <strong>{user?.email}</strong> isn't approved for the IDP rate
                card. Access is invite-only — contact Nventr to have your
                email added.
              </p>
              <button className="cs-btn cs-btn-outline cs-btn-sm" onClick={() => signOut()}>
                Sign out
              </button>
            </>
          ) : (
            <>Couldn't load the rate card: {error}</>
          )}
        </div>
      </div>
    );
  }
  if (sections === null) {
    return (
      <div className="cs-page">
        <div className="cs-empty">Loading the rate card…</div>
      </div>
    );
  }

  return (
    <div className="cs-page cs-plan">
      <h1>IDP — Enterprise Rate Card</h1>
      <p className="cs-store-note">
        Intelligent Document Processing services on the nventr platform ·
        Confidential — internal & enterprise-engagement use only · derived
        from the July 2026 production rate analysis · August 2026.
      </p>

      <nav className="cs-plan-toc">
        {sections.map((s) => (
          <a key={s.id} href={`#${s.id}`}>{s.title}</a>
        ))}
      </nav>

      {sections.map((s) => (
        <section key={s.id} id={s.id} className="cs-plan-section">
          <h2>{s.title}</h2>
          <MarkdownLite text={s.body} />
        </section>
      ))}
    </div>
  );
}
